import React, { MouseEventHandler } from 'react';
import './VXButton.css';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'icon';
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'destructive' | 'destructive-ghost';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const VXButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className = '',
      size = 'md',
      variant = 'primary',
      isLoading,
      disabled,
      children,
      leftIcon,
      rightIcon,
      onClick,
      ...props
    },
    ref,
  ) => {
    const isIconOnly = !children && (leftIcon || rightIcon);
    const iconOnlyClass = isIconOnly ? 'vx-btn--icon-only' : '';

    const baseClass = 'vx-btn';
    const sizeClass = `vx-btn--${size}`;
    const variantClass = `vx-btn--${variant}`;
    const loadingClass = isLoading ? 'vx-btn--loading' : '';

    const classes = [baseClass, sizeClass, variantClass, loadingClass, iconOnlyClass, className]
      .filter(Boolean)
      .join(' ');

    return (
      <button
        type="button"
        ref={ref}
        className={classes}
        disabled={disabled || isLoading}
        onClick={onClick}
        {...props}
      >
        {isLoading && <i className={'fa-spinner fa-spin'}></i>}

        {!isLoading && leftIcon && <span className="vx-btn__icon-left">{leftIcon}</span>}

        {children}

        {!isLoading && rightIcon && <span className="vx-btn__icon-right">{rightIcon}</span>}
      </button>
    );
  },
);

VXButton.displayName = 'Button';
